export default {
   candidate: {}
}